export const reservationKeys = {
  byId: (id: string) => ['reservation', id] as const,
  allByEstimate: (estimateId: string) => ['reservations', 'estimate', estimateId] as const,
  byEstimate: (estimateId: string, isTreated?: boolean) =>
    ['reservations', 'estimate', estimateId, isTreated] as const,
  byEstimateResponse: (responseId: string) =>
    ['reservation', 'estimate-response', responseId] as const,
}
